export { default } from './page/_index.tsx';
import { json, LinksFunction } from '@remix-run/node';
import type { MetaFunction } from '@remix-run/node';
import { externalAction, externalLoader } from '~/utils/externalLoader.server';
export const action = externalAction;
export const loader = externalLoader;
//! remove later
// export const action = async () => {
// 	return json({ message: 'Not Found' }, { status: 404 });
// };
// export const loader = async () => {
// 	return json({ message: 'Not Found' }, { status: 404 });
// };
//! remove later
import { useTranslation } from 'react-i18next';

export const meta: MetaFunction = ({ data }: any) => {
	let { t } = useTranslation(['project_md-app']);

	let lang = data.userLanguage === 'de' ? '' : data.userLanguage + '/';

	return [
		{
			title: t('routeTitle'),
		},
		{
			name: 'title',
			content: t('routeTitle'),
		},
		{
			property: 'og:title',
			content: t('routeTitle'),
		},
		{
			name: 'twitter:title',
			content: t('routeTitle'),
		},
		{
			name: 'description',
			content: t('routeOther'),
		},
		{
			name: 'og:description',
			content: t('routeOther'),
		},
		{
			name: 'twitter:description',
			content: t('routeOther'),
		},
		{
			property: 'og:url',
			content: 'https://northrock.software/' + lang + 'references/md-app/',
		},
		{
			name: 'twitter:url',
			content: 'https://northrock.software/' + lang + 'references/md-app/',
		},
	];
};

import conclution from '~/content/images/references/md-app/app-view2.webp';
import clientMD from '~/content/svg/clients/mde.webp';
import website_hero_md_app from '~/content/images/references/md-app/md-dashboard-home.webp';
import md_app from '~/content/images/references/md-app/app-view.webp';
import md_app2 from '~/content/images/references/md-app/user.webp';
import rust from '~/content/images/references/technologies/rust.webp';
import tauri from '~/content/images/references/technologies/tauri.webp';
import google_api from '~/content/images/references/technologies/google_api.webp';
import react2 from '~/content/images/references/technologies/react.webp';
import sentry from '~/content/images/references/technologies/sentry.webp';
import hetzner from '~/content/images/references/technologies/hetzner.webp';

export const links: LinksFunction = () => {
	return [
		{
			rel: 'preload',
			href: conclution,
			as: 'image',
		},
		{
			rel: 'preload',
			href: clientMD,
			as: 'image',
		},
		{
			rel: 'preload',
			href: website_hero_md_app,
			as: 'image',
		},
		{
			rel: 'preload',
			href: md_app,
			as: 'image',
		},
		{
			rel: 'preload',
			href: md_app2,
			as: 'image',
		},
		{
			rel: 'preload',
			href: rust,
			as: 'image',
		},
		{
			rel: 'preload',
			href: tauri,
			as: 'image',
		},
		{
			rel: 'preload',
			href: google_api,
			as: 'image',
		},
		{
			rel: 'preload',
			href: react2,
			as: 'image',
		},
		{
			rel: 'preload',
			href: sentry,
			as: 'image',
		},
		{
			rel: 'preload',
			href: hetzner,
			as: 'image',
		},
	];
};
